export default __webpack_public_path__ + "static/media/ramp_walkthrough_1.ae16514e.bin";